import { callApiWithToken } from "../utils/http_common";

const getMyAccountList = () => {
  return callApiWithToken.get(`/account/list`);
};

const getWalletAddress = (body) => {
  return callApiWithToken.get(`/account/getWalletAddress`, {
    params: {
      currency: body.currency,
      network: body.network,
      amount: body.amount,
    },
  });
};

const getBalance = (currency) => {
  return callApiWithToken.get(`/account/getBalance`, {
    params: {
      currency: currency,
    },
  });
};

const getBalanceV2 = () => {
  return callApiWithToken.get(`/account/getBalanceV2`, {});
};
const AccountServide = {
  getMyAccountList,
  getWalletAddress,
  getBalance,
  getBalanceV2,
};

export default AccountServide;
